module.exports = __webpack_public_path__ + "img/long-arrow-alt-left-solid.dd394416.svg";